module.exports = __webpack_public_path__ + "static/media/team-bg-2.5ed35a47.jpg";